import { useQuery } from '@tanstack/react-query';
import { getStoreDetailsBySubdomain } from '@api/customer-portal-api';
import { queryKeys } from '@hooks/queryKeys';
import { normalizeCustomerPortalLogoSize } from '@lib/customerPortalLogoSize';

export interface StoreCustomStyles {
  id: string;
  primaryBackgroundColor: string | null;
  secondaryBackgroundColor: string | null;
  primaryTextColor: string | null;
  secondaryTextColor: string | null;
  buttonBackgroundColor: string | null;
  buttonTextColor: string | null;
  logo: string | null;
  logoSize: number;
}

interface UseStoreDetailsResult {
  styles: StoreCustomStyles | null;
  notFound: boolean;
}

export const useStoreDetails = (domain: string) =>
  useQuery({
    queryKey: queryKeys.store.byDomain(domain),
    queryFn: async (): Promise<UseStoreDetailsResult> => {
      if (!domain) return { styles: null, notFound: false };
      const response = await getStoreDetailsBySubdomain(domain);
      if (!response.success || response.status === 404) {
        return { styles: null, notFound: true };
      }
      const d = response.data?.storeDetails;
      if (!d) return { styles: null, notFound: false };
      return {
        styles: {
          id: d._id,
          primaryBackgroundColor: d.customer_portal_background_color,
          secondaryBackgroundColor: d.customer_portal_secondary_background_color,
          primaryTextColor: d.customer_portal_primary_text_color,
          secondaryTextColor: d.customer_portal_secondary_text_color,
          buttonBackgroundColor: d.customer_portal_button_background_color,
          buttonTextColor: d.customer_portal_button_text_color,
          logo: d.customer_portal_logo || d.store_logo,
          logoSize: normalizeCustomerPortalLogoSize(d.customer_portal_logo_size),
        },
        notFound: false,
      };
    },
    staleTime: 5 * 60_000,
  });
